// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading1_h1__-OZhQ","subeading":"Heading1_subeading__1trcS"};